import {createContext} from 'react';

export enum PageContextSectionEnum {
  PRICE = 'price', // Holds value for "show yearly price" toggle, and state change method
  TOC = 'toc' // Holds all the Header components that builds a TOC
}

export const PageContext = createContext({
  [PageContextSectionEnum.PRICE]: undefined,
  [PageContextSectionEnum.TOC]: undefined
});
